import { ActionTree, MutationTree, GetterTree } from 'vuex';
import Module from '../interfaces/module.interface';
import { FlagsState } from './flagsType';
import { RootState } from '../types';
import { IRouterProps } from '@/router/interfaces/router-props.interface';

export const state: FlagsState = new FlagsState([]);

const factory = async (context: IRouterProps) => {
  const items = JSON.parse(sessionStorage.getItem('dashboard-flags') || "['']");
  context.store.dispatch('flags/SET_FLAGS', items);
};

const actions: ActionTree<FlagsState, RootState> = {
  SET_FLAGS(context, payload: FlagsState) {
    context.commit('setFlags', payload);
  }
};

const mutations: MutationTree<FlagsState> = {
  setFlags(state, payload: string[]) {
    state.flags = payload;
  }
};

const getters: GetterTree<FlagsState, RootState> = {
  getFlags(state) {
    return state.flags;
  }
};

const namespaced: boolean = true;

export const flags: Module<FlagsState, RootState> = {
  namespaced,
  initializer: {
    factory,
    provide: 'FlagStore',
    on: 'BeforeEachRoute'
  },
  state,
  actions,
  mutations,
  getters
};
